import { useCallback, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import searchLogApi from 'api/requests/searchLog';

/**
 * Sessão de busca para o registro da API (ver plans/search-improvements.md no
 * app): os pedidos da mesma intenção — termo refinado, filtro trocado — levam
 * o mesmo `search_session`, e a análise usa o último. Depois de abrir um
 * resultado, a próxima busca já é outra intenção; outro resultado da mesma
 * lista ainda é a mesma.
 *
 * - `sessionFor()`: o id a mandar no pedido de busca (renova se houve clique).
 * - `reset()`: busca limpa ou fechada — a próxima começa do zero.
 * - `logClick(type, item, position)`: resultado aberto ('event' | 'establishment').
 */
export function useSearchSession() {
    const sessionRef = useRef(uuidv4());
    const clickedRef = useRef(false);

    const reset = useCallback(() => {
        sessionRef.current = uuidv4();
        clickedRef.current = false;
    }, []);

    const sessionFor = useCallback(() => {
        if (clickedRef.current) reset();

        return sessionRef.current;
    }, [reset]);

    const logClick = useCallback((itemType, item, position) => {
        if (!item?.slug) return;

        // Registrar nunca atrapalha a navegação.
        searchLogApi.click({
            search_session: sessionRef.current,
            item_type: itemType,
            item_slug: item.slug,
            position,
        }).catch(() => {});

        clickedRef.current = true;
    }, []);

    return { sessionFor, reset, logClick };
}
